// extracted by mini-css-extract-plugin
export default {"divider":"divider__xIyzl","userName":"userName__wqDw8"};